import Coupon from 'features/BetSlip2/BettingREST/DataObjects/Coupon';

class QuinellaCoupon extends Coupon {
    marks = '';
    standoutMarks = '';
}

export default QuinellaCoupon;
